import React, { PropsWithChildren } from 'react';

import { Box, Text } from '@opendoor/bricks-next';
import { Flex, Heading } from '@opendoor/bricks/core';

type ValueProp = {
  header: string;
  description: string;
};

interface IProps {
  valueProps: Array<ValueProp>;
}

const Item: React.FC<PropsWithChildren> = (props) => (
  <Box
    width="100%"
    $largerThanSM={{ width: '25%', marginBottom: 0 }}
    style={{ textAlign: 'left' }}
    marginBottom="$8x"
  >
    {props.children}
  </Box>
);

const Title: React.FC<PropsWithChildren> = (props) => (
  <Heading
    size="UNSAFE_h4"
    as="h4"
    fontSize={['s1', 's2']}
    fontWeight="bolder"
    width={['100%', '100%', '80%']}
    lineHeight="header"
    mb={[4, null, null, 6]}
    color="neutrals0"
    height={[null, null, '60px']}
  >
    {props.children}
  </Heading>
);

const Description: React.FC<PropsWithChildren> = (props) => (
  <Text
    tag="p"
    ml={0}
    color="$contentInversePrimary"
    typography="$bodySmall"
    width="80%"
    $largerThanMD={{ width: '85%' }}
  >
    {props.children}
  </Text>
);

const ValuePropsSection = (props: IProps) => (
  <Flex mt={[11, null, 12]} flexDirection="column" width="100%" textAlign="center">
    <Flex
      alignItems="flex-start"
      justifyContent="evenly-spaced"
      flexDirection={['column', 'column', 'row', 'row']}
      margin="auto"
    >
      {props.valueProps.map((valueProp: ValueProp, i: number) => {
        return (
          <Item key={i}>
            <Title>{valueProp.header}</Title>
            <Description>{valueProp.description}</Description>
          </Item>
        );
      })}
    </Flex>
  </Flex>
);

export default ValuePropsSection;
